<template slot-scope="scope">
  <!-- 绑定/更换银行卡 -->
      <dialogModel
        :title="PopUpTitle"
        :visible="dialogBank"
        @handleClose="handleCancelBank"
        @handleOk="handleVerifyBank"
      >
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <!-- 开户行 -->
            <div class="form-item">
              <div class="tit-p"><span style="color: red">*</span>开户银行：</div>
              <div class="content">
                <el-form-item prop="value">
                  <el-select v-model="ruleForm.value" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <!-- 开户行地址 -->
            <div class="form-item">
              <div class="tit-p">
                <span style="color: red">*</span>开户银行地址：
              </div>
              <div class="content">
                <el-form-item prop="address">
                  <el-input
                    v-model="ruleForm.address"
                    placeholder="请输入开户银行地址"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <!-- 银行账号 -->
            <div class="form-item">
              <div class="tit-p"><span style="color: red">*</span>银行账号：</div>
              <div class="content">
                <el-form-item prop="Account">
                  <el-input
                    v-model="ruleForm.Account"
                    placeholder="请输入银行账号"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <!-- 绑定手机号 -->
            <div class="form-item">
              <div class="tit-p"><span style="color: red">*</span>绑定手机号：</div>
              <div class="content">
                <el-form-item prop="phone">
                  <el-input
                    v-model="ruleForm.phone"
                    placeholder="请输入绑定银行手机号"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <!-- 验证码 -->
            <div class="form-item">
              <div class="tit-p"><span style="color: red">*</span>验证码：</div>
              <div class="content">
                <el-form-item prop="Code">
                  <el-input
                    v-model="ruleForm.Code"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-button type="primary"
                  class="verify"
                  @click="second == 60 ? handelInvoke('ruleForm') : ''"
                >{{
                    second === totalSecond && sendNum == 0
                      ? "获取验证码"
                      : second === totalSecond && sendNum != 0
                      ? "再次获取验证码"
                      : second + `秒后重新发送`
                  }}</el-button>
              </div>
            </div>
          </el-form>
      </dialogModel>
</template>

<script>
// 引入接口
import {
  postSendAuthCode, // 获取邮箱/手机验证码
} from "../../../../../assets/api/index";
// 封装的表单验证
import { vxRule } from "../../../../../../untils/FormValidation/validate-form";

// 在弹窗中获取验证码 destroyed中的应写在handleClose/handleUnderstand中才生效
export default {
  props: {
    dialogBank: {},
    PopUpTitle: {},
  },
  components: {},
  data() {
    return {
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码
      ruleForm: {
        value: "", // 开户行
        address: "", //开户行地址
        Account: "", // 银行账号
        phone: "", // 手机号
        Code: "", // 验证码
      },
      options: [],
      rules: {
        // 参数3 change触发，为空时使用自定义提示语    blur
        // 参数4 自定义提示语 / 没有时用封装的
        // 参数2 封装的规则名 / 自定义规则
        // 参数1 false时不验证为空
        value: vxRule(true, "", ["blur", "change"], "请选择开户银行"),
        address: vxRule(true, "", ["blur", "change"], "请输入开户银行地址"),

        Code: vxRule(true, "", ["blur", "change"], "请输入验证码"),
        Account: [
          {
            required: true,
            message: "请输入银行账号",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入数字",
            trigger: ["blur", "change"],
            pattern: /^\d+$/, // 只能输入数字，且至少输入1位
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入绑定银行手机号",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的电话号码",
            trigger: ["blur", "change"],
            pattern:
              /^\s*(1[3-9]\d{9})|((0\d{2,3})-?\d{7,8}(-\d{1,4})?)|(400|800)-?\d{3,4}-?\d{3,4}\s*$/,
          },
        ],
      }, // 表单验证
    };
  },
  watch: {
    // 监听
    dialogBank: {
      handler(newSs, old) {
        if (newSs == false) {
          this.ruleForm = {
            value: "", // 开户行
            address: "", //开户行地址
            Account: "", // 银行账号
            phone: "", // 手机号
            Code: "", // 验证码
          };
          // 关闭验证码倒计时 数据归位
          clearInterval(this.timer);
          this.timer = null; // 重置定时器 id
          this.second = this.totalSecond; // 归位
          this.sendNum = "0";

          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 300);
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  destroyed() {
    clearInterval(this.timer);
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  methods: {
    // ---------------------------- 点击发送验证码 接口 -----------------------
    handelInvoke(formName) {
      // 单独查看手机号是否校验成功
      this.$refs[formName].validateField("phone", (errMsg) => {
        if (errMsg) {
          console.log("校验未通过");
        } else {
          console.log(3);
          // // 获取验证码接口
          // var data = {};
          // data.data = {
          //   mail: this.$store.getters.getUser.mail,
          //   mobile: this.$store.getters.getUser.phone,
          //   type: 0,
          // };
          // postSendAuthCode(data).then((res) => {
          //   if (res.code == 0) {
          //     this.Countdown();
          //     this.$tool.PromptBox("success", "验证码已发送");
          //   } else {
          //     // 验证码发送失败
          //     this.$tool.PromptBox("error", "验证码发送失败");
          //   }
          // });
        }
      });
    },
    // 发送验证码
    Countdown() {
      this.textCode = false;
      var that = this;
      setTimeout(function () {
        that.sendNum++;
        console.log(that.sendNum);
        // 时间间隔
      }, 1000);

      // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
      if (!this.timer && this.second === this.totalSecond) {
        console.log("111");
        // 开启倒计时
        this.timer = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            clearInterval(this.timer);
            this.timer = null; // 重置定时器 id
            this.second = this.totalSecond; // 归位
          }
        }, 1000);
      }
    },

    // 取消 关闭弹窗
    handleCancelBank() {
      this.$emit("handleCancelBank");
    },

    // 确认
    handleVerifyBank() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("handleVerifyBank");
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  margin-bottom: 0px;
  // height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}

/deep/.el-input__inner {
  //   width: 250px;
  height: 35px !important;
  border: 1px solid #409eff ;
}
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  div {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.form-item {
    width: 470px;
    min-height: 35px;
    margin: 0 auto;
    margin-bottom: 30px;
    display: flex;
    .tit-p {
      width: 110px;
      height: 35px;
      line-height: 35px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #333333;
      text-align: right;
      font-weight: 400;
    }
    .content {
      flex: 1;
      height: 35px;
      position: relative;
      .verify {
        position: absolute;
        top: 10px;
        right: 20px;
        color: #409eff ;
        cursor: pointer;
      }
    }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}
</style>
